import { all, call, put, select, take, takeEvery } from 'redux-saga/effects';
import i18next from 'i18next';
import { Url } from '@wix/da-url';
import { reduxModuleLoaded, subscribeToTier, unsubRequest, unsubRequestByUsername, changeTier, pushChangeTierModal } from './actions';
import { request } from '../../../xhr';
import { isApiError } from '../../../xhr/request';
import { pushModal, replaceModal, popModal } from '../../../Modals/redux/basicActions';
import { ModalType } from '../../../Modals/redux/types';
import { getCurrentUser } from '../../../publicSession/selectors';
export function fakeUnsubscribeResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        if (window.doError) {
            return {
                error: 'invalid_request',
                error_description: 'Not logged in.',
                status: 'error'
            };
        }
        return {
            success: true
        };
    }
}
export function fakeCheckUpgradeResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        if (window.doError) {
            return {
                error: 'invalid_request',
                error_description: 'Not logged in.',
                status: 'error'
            };
        }
        return {};
    }
}
function* handleSubscribeToTier({ payload: { tier  }  }) {
    var _tier_author, _tier_tier;
    // Step 0: Check that we're not the author
    const currentUser = yield select(getCurrentUser);
    if (currentUser.username === ((_tier_author = tier.author) === null || _tier_author === void 0 ? void 0 : _tier_author.username)) {
        yield put(pushModal(ModalType.CONFIRMATION, {
            params: {
                withCancelButton: false,
                title: i18next.t('deviation.tier.changePopup.selfSubFailure.title'),
                text: i18next.t('deviation.tier.changePopup.selfSubFailure.text'),
                confirmBtnLabel: i18next.t('deviation.tier.changePopup.selfSubFailure.accept')
            }
        }));
        return;
    }
    // Step 1: Check if we need to unsubscribe from an existing tier
    const response = yield call(request, {
        method: 'get',
        url: '/tier/check_upgrade',
        params: {
            tierid: (_tier_tier = tier.tier) === null || _tier_tier === void 0 ? void 0 : _tier_tier.tierId
        }
    }, fakeCheckUpgradeResponse);
    if (isApiError(response)) {
        yield put(pushModal(ModalType.CONFIRMATION, {
            params: {
                withCancelButton: false,
                title: i18next.t('deviation.tier.changePopup.failure.title'),
                text: i18next.t('deviation.tier.changePopup.failure.body'),
                confirmBtnLabel: i18next.t('deviation.tier.changePopup.failure.accept')
            }
        }));
        return;
    }
    if (response === null || response === void 0 ? void 0 : response.currentTier) {
        yield put(pushChangeTierModal(response === null || response === void 0 ? void 0 : response.currentTier, tier, response === null || response === void 0 ? void 0 : response.isDowngrade));
    } else {
        var _tier_tier1;
        if ((_tier_tier1 = tier.tier) === null || _tier_tier1 === void 0 ? void 0 : _tier_tier1.subproductId) {
            var _tier_tier2;
            window.location.href = Url.checkoutLink((_tier_tier2 = tier.tier) === null || _tier_tier2 === void 0 ? void 0 : _tier_tier2.subproductId);
        }
    }
}
function* handleUnsubRequest({ payload: { tier  }  }) {
    var _tier_tier;
    const response = yield call(request, {
        method: 'post',
        url: '/tier/unsubscribe',
        data: {
            tierid: (_tier_tier = tier.tier) === null || _tier_tier === void 0 ? void 0 : _tier_tier.tierId
        }
    }, fakeUnsubscribeResponse);
    yield put(popModal());
    if (isApiError(response)) {
        yield put(pushModal(ModalType.CONFIRMATION, {
            params: {
                withCancelButton: false,
                title: i18next.t('deviation.tier.unsubPopup.failure.title'),
                text: i18next.t('deviation.tier.unsubPopup.failure.body'),
                confirmBtnLabel: i18next.t('deviation.tier.unsubPopup.failure.accept')
            }
        }));
        return;
    }
    const reloadPage = ()=>{
        window.location.reload();
    };
    yield put(pushModal(ModalType.CONFIRMATION, {
        params: {
            withCancelButton: false,
            title: i18next.t('deviation.tier.unsubPopup.success.title'),
            text: i18next.t('deviation.tier.unsubPopup.success.body', {
                tierName: tier.title
            }),
            confirmBtnLabel: i18next.t('deviation.tier.unsubPopup.success.accept'),
            // Refresh any stale state
            onConfirm: reloadPage,
            onCancel: reloadPage
        }
    }));
}
function* handleUnsubRequestByUsername({ payload: { username  }  }) {
    const response = yield call(request, {
        method: 'post',
        url: '/tier/user/unsubscribe',
        data: {
            subscribed_to_username: username
        }
    }, fakeUnsubscribeResponse);
    if (isApiError(response)) {
        yield put(replaceModal(ModalType.CONFIRMATION, {
            params: {
                withCancelButton: false,
                title: i18next.t('deviation.tier.unsubPopup.failure.title'),
                text: i18next.t('deviation.tier.unsubPopup.failure.body'),
                confirmBtnLabel: i18next.t('deviation.tier.unsubPopup.failure.accept')
            }
        }));
        return;
    }
    const redirectToSubscriptions = ()=>{
        window.location.href = Url.userSubscriptionsPath({
            username
        });
    };
    // We have to use replaceModal to keep the <TierConsumerReduxModule />
    // loaded and keep this saga active until the final confirmation modal is shown
    yield put(replaceModal(ModalType.CONFIRMATION, {
        params: {
            withCancelButton: false,
            title: i18next.t('deviation.tier.unsubPopup.success.title'),
            text: i18next.t('deviation.tier.unsubPopup.success.body.generic'),
            confirmBtnLabel: i18next.t('deviation.tier.unsubPopup.success.accept'),
            // Refresh any stale state
            onConfirm: redirectToSubscriptions,
            onCancel: redirectToSubscriptions
        }
    }));
}
function* handleChangeTier({ payload: { currentTier , newTier  }  }) {
    var _currentTier_tier, _newTier_tier;
    const response = yield call(request, {
        method: 'post',
        url: '/tier/unsubscribe',
        data: {
            tierid: (_currentTier_tier = currentTier.tier) === null || _currentTier_tier === void 0 ? void 0 : _currentTier_tier.tierId
        }
    }, fakeUnsubscribeResponse);
    if (isApiError(response)) {
        yield put(pushModal(ModalType.CONFIRMATION, {
            params: {
                withCancelButton: false,
                title: i18next.t('deviation.tier.changePopup.failure.title'),
                text: i18next.t('deviation.tier.changePopup.failure.body'),
                confirmBtnLabel: i18next.t('deviation.tier.changePopup.failure.accept')
            }
        }));
        return;
    }
    if ((_newTier_tier = newTier.tier) === null || _newTier_tier === void 0 ? void 0 : _newTier_tier.subproductId) {
        var _newTier_tier1;
        window.location.href = Url.checkoutLink((_newTier_tier1 = newTier.tier) === null || _newTier_tier1 === void 0 ? void 0 : _newTier_tier1.subproductId);
    }
}
export default function* subscribeSaga() {
    yield take(reduxModuleLoaded);
    yield all([
        takeEvery(subscribeToTier, handleSubscribeToTier),
        takeEvery(unsubRequest, handleUnsubRequest),
        takeEvery(unsubRequestByUsername, handleUnsubRequestByUsername),
        takeEvery(changeTier, handleChangeTier)
    ]);
}
